<template>
  <div class="row mx-2 my-3 pricelist-settings">
      <div class="col-md-12">
          <div class="row">
              <div class="col-sm-12 col-md-7">
                  <h3>Login Records</h3>
              </div>
              <div class="col-sm-12 col-md-3 text-right">
                  
              </div>
              <div class="col-sm-12 col-md-2 text-right">
                  
              </div>
          </div>
          <table
              class="table table-responsive table-striped border-bottom mt-2"
          >
              <thead class="thead-light">
                  <tr>
                      <th>#</th>
                      <th>Email</th>
                      <th>IP Address</th>
                      <th>Success?</th>
                  </tr>
              </thead>
              <tbody>
                  <template
                      v-for="(item, key) in allLoginRecords?.data"
                      :key="item.id"
                  >
                      <tr>
                        <td>{{ key+1 }}</td>
                        <td>{{ item.email }}</td>
                        <td>{{ item.ip_address }}</td>
                        <td>
                          <i v-if="item.success" class="fas fa-check-circle text-success"></i>
                          <i v-else class="fa-solid fa-circle-xmark text-danger"></i>
                        </td>
                      </tr>
                  </template>
              </tbody>
          </table>

          <Bootstrap4Pagination
            v-if="allLoginRecords"
            :data="allLoginRecords"
            @pagination-change-page="getResults"
            :align="'right'"
            :limit="1"
            :keepLength="true"
          >
              <template #prev-nav>
                  <i class="fa fa-arrow-left"></i> PREVIOUS</template
              >
              <template #next-nav>
                  NEXT <i class="fa fa-arrow-right"></i>
              </template>
          </Bootstrap4Pagination>
      </div>

  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Bootstrap4Pagination } from "laravel-vue-pagination";
import Confirmation from "@/components/Confirmation.vue";

export default {
  props: [],
  emits: [],
  components: {
      Bootstrap4Pagination,
      Confirmation
  },
  setup() {
      const store = useStore();
      const route = useRoute();

      let user = computed(function () {
          return store.state.user;
      });

      const allLoginRecords = computed(() => store.getters["setting/allLoginRecords"]);

      onMounted(async () => {
        await store.dispatch('setting/getAllLoginRecords', {page: 1});
      });

      return {
          store,
          route,
          user,
          allLoginRecords,
      };
  },
  
  data() {
    return {
      search: '',
      debouncedFunction: null
    };
  },
  methods: {
    async getResults(page = 1) {
      try {
        await this.store.dispatch('setting/getAllLoginRecords', {page: page})
      } catch (error) {
        console.error(err);
      }
    }
  }
};
</script>
